// extracted by mini-css-extract-plugin
export default {"faq_answer":"index__faq_answer___V25Ll"};